
<div :class="jel_getClassObject(content)">
  <div class="container p-0">
    <div
      v-if="isSpinnerVisible"
      id="spinner"
      class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
    >
      <b-spinner :label="$t('chargement')"></b-spinner>
    </div>

    <div class="row">
      <div class="col text-left">
        <b-link
          v-bind="jel_getLienBinding(content.lienRetour)"
          class="d-none d-md-block lien-retour btnVide p-0 mb-2"
        >
          <svg-icon
            icon-name="fleche-gauche"
            className="icone-fleche mySvg"
            :class="content.lien.cssIcone"
          ></svg-icon>
          <span class="graphik_semibold lien-retour pl-0 pt-sm-n1">{{
            content.libLienRetour
          }}</span>
        </b-link>

        <Titre
          :content="{
            type: 'grandTitre',
            titre: content.titre,
            classeCSS: 'text-left mb-2',
          }"
        >
        </Titre>

        <b-img-lazy
          v-if="content.image"
          :src="jel_getFichierSrc(content.image)"
          class="mx-md-0 mx-auto d-block mb-2"
        />

        <!-- Affichage des erreurs systèmes -->
        <div v-if="isErreurServeur">
          <MessageMel
            v-show="contentMessageMel.message"
            :content="contentMessageMel"
            class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
          ></MessageMel>

          <!-- En cas d'erreur système, on appelle la même méthode du début du processus au mounted (verifierStatutClient) -->
          <button
            class="btn btn-primaire d-block mx-md-0 mx-auto px-4 mt-2"
            @click="erreurServerReessayer()"
          >
            {{ content.libReessayer }}
          </button>
        </div>
        <!-- Aucune erreur système (cas normal)  -->
        <div v-else>
          <!-- CLIENT GUEST -->
          <div v-show="statutClient === 'guest'">
            <Paragraphe
              :content="{
                richText: content.txtClientsGuest,
                classeCSS: 'pb-1',
              }"
            ></Paragraphe>
            <button
              class="btn btn-primaire d-block mx-md-0 mx-auto px-4"
              @click="redirectToValidation()"
            >
              {{ content.libPoursuivreInscription }}
            </button>
          </div>

          <!-- CLIENT JOUEUR -->
          <div v-show="statutClient === 'joueur'">
            <!-- Si le client a déjà une carte associée -->
            <div v-if="numeroCarte">
              <!-- Modale de confirmation du choix de retrait de la carte -->
              <b-modal
                id="retrait-carte"
                body-class="py-5 px-4 compteClair"
                centered
                hide-header-close
                no-hide-backdrop
                no-close-on-backdrop
                no-close-on-esc
                hide-footer
                hide-header
              >
                <div class="contenu-modal-retrait">
                  <Titre
                    :content="{
                      type: 'sousTitre',
                      titre: jel_replaceTokens(content.titreModaleRetraitCarte),
                      classeCSS: 'titre-modal mb-2 pt-1',
                    }"
                  >
                  </Titre>

                  <Paragraphe
                    :content="{
                      richText: content.txtModaleRetraitCarte,
                      classeCSS: 'contenu-texte-modal pb-2',
                    }"
                  ></Paragraphe>

                  <button
                    class="btn-modal-confirm btn btn-primaire d-block mx-auto px-8 mb-2"
                    @click="confirmerRetraitCarte()"
                  >
                    {{ content.libConfirmerRetrait }}
                  </button>

                  <button
                    class="btn-modal-cancel d-block mx-auto px-4 my-0"
                    @click="fermerModaleRetraitCarte()"
                  >
                    {{ content.libAnnulerRetrait }}
                  </button>
                </div>
              </b-modal>

              <MessageMel
                v-show="contentMessageMel.message"
                :content="contentMessageMel"
                class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
              ></MessageMel>

              <!-- afficher le numéro de carte et bouton pour la retirer sauf si la carte est devenue inactive après l'association -->
              <div v-if="erreurObtenirCarteInactive">
                <div class="numero-carte-inactive">
                  <p class="d-inline-block mr-1" v-html="content.txtNumeroDeMembre"></p>
                  <div class="d-inline-block" v-html="numeroCarte"></div>
                </div>
              </div>
              <!-- carte active -->
              <div v-else>
                <Paragraphe
                  :content="{
                    richText: content.txtClientsMembreInfoSupplementaire,
                  }"
                ></Paragraphe>

                <!-- Section points Statut Casino -->
                <div v-if="point">
                  <Titre
                    :content="{
                      type: 'titre',
                      titre: content.titreSectionPoints,
                      classeCSS: 'text-left pt-4',
                    }"
                  >
                  </Titre>
                  <div class="col-sm-10 p-0 section-points">
                    <div v-if="point.lastUpdate" class="note">
                      {{ $t('messageComponent.enDateDu', lastUpdateDateTime) }}*
                    </div>
                    <div class="mt-1 p-3 zone-pts">
                      <b-row>
                        <b-col><div v-html="content.libPointsEnLigne" /></b-col>
                        <b-col
                          ><b-row>
                            <b-col class="col-12 text-right absolute-bottom">{{
                              Math.floor(point.online).toLocaleString($i18n.locale)
                            }}</b-col>
                            <!-- TODO: Retirer (2023-11-02) -->
                            <!-- <b-col class="col-5 pl-1 pr-0">{{
                              $tc('messageComponent.point', point.online)
                            }}</b-col> -->
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col><div v-html="content.libPointsEnEtablissements" /></b-col>
                        <b-col>
                          <b-row>
                            <b-col class="col-12 text-right absolute-bottom">{{
                              Math.floor(point.landBased).toLocaleString($i18n.locale)
                            }}</b-col>
                            <!-- TODO: Retirer (2023-11-02) -->
                            <!-- <b-col class="col-5 pl-1 pr-0">{{
                              $tc('messageComponent.point', point.landBased)
                            }}</b-col> -->
                          </b-row></b-col
                        >
                      </b-row>
                      <b-row class="graphik_semibold pt-1">
                        <b-col><div v-html="content.libPointsTotaux" /></b-col>
                        <b-col>
                          <b-row>
                            <b-col class="col-12 text-right absolute-bottom">{{
                              Math.floor(point.total).toLocaleString($i18n.locale)
                            }}</b-col>
                            <!-- TODO: Retirer (2023-11-02) -->
                            <!-- <b-col class="col-5 pl-1 pr-0">{{
                              $tc('messageComponent.point', point.total)
                            }}</b-col> -->
                          </b-row></b-col
                        >
                      </b-row>
                    </div>
                    <p class="px-0 note mt-1" v-html="content.txtMajPoints" />

                    <div v-if="point.total === 0">
                      <Hyperlien :content="contentLienAucunPoint"></Hyperlien>
                    </div>

                    <!-- Statut de membre -->
                    <Titre
                      :content="{
                        type: 'titre',
                        titre: content.titreSectionStatut,
                        classeCSS: 'text-left pb-1 pt-4',
                      }"
                    >
                    </Titre>
                    <div class="section-statut">
                      <p class="txt-statut graphik_semibold">{{ point.status }}</p>
                      <img
                        v-if="imageStatut"
                        class="mb-3"
                        :src="imageStatut"
                        :alt="$t('messageComponent.altStatut') + ' ' + point.status"
                      />
                      <Hyperlien :content="contentLienAideStatuts"></Hyperlien>
                    </div>
                  </div>
                </div>

                <div
                  class="mt-4 d-inline-block mr-1 graphik_medium note"
                  v-html="content.txtNumeroDeMembre"
                ></div>
                <div class="mb-2 mr-2 d-inline-block note" v-html="numeroCarte"></div>
                <a class="retraitCarte graphik_medium note" @click="ouvrirModaleRetraitCarte()">{{
                  content.libLienRetraitCarte
                }}</a>
              </div>
            </div>
            <div v-else>
              <div v-if="consentementClient">
                <!-- Le client a donné son consentement -->
                <!-- Pas de numéro de carte, il faut le saisir -->
                <div v-if="appariementValide">
                  <div v-if="erreurApparimentSuccesMaisCarteInactive">
                    <!-- Client est valide et apparié et sa carte est devenue inactive -->
                    <Paragraphe
                      :content="{
                        richText: content.txtPageErreurCarteInactive,
                      }"
                    ></Paragraphe>
                  </div>
                  <!-- Autre cas pour ObtenirCarte -->
                  <div v-else>
                    <div v-if="erreurObtenirCarte">
                      <!-- Ici le client est valide et apparié mais il y a une erreur avec la carte (autre que carte inactive gérer précédement) -->
                      <!-- On affiche donc le message d'erreur et rien d'autre -->
                      <MessageMel
                        v-show="contentMessageMel.message"
                        :content="contentMessageMel"
                        class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
                      ></MessageMel>
                    </div>
                    <div v-else>
                      <!-- client appariement valide et aucune erreur avec ObtenirCarte -->
                      <Titre
                        :content="{
                          type: 'titre',
                          titre: content.titreSaisieCarte,
                          classeCSS: 'text-left pt-1 pb-1',
                        }"
                      >
                      </Titre>

                      <Paragraphe
                        :content="{
                          richText: content.txtSaisieCarte,
                          classeCSS: 'p-0',
                        }"
                      ></Paragraphe>

                      <b-form-group :label="content.libNumeroCarte" label-for="numeroCarte">
                        <b-form-input
                          :id="content.idHTML ? content.idHTML : 'numeroCarte'"
                          v-model="inputNumeroCarte"
                          v-remove-extra-spaces
                          trim
                          type="text"
                          maxlength="10"
                          autocomplete="off"
                          class="mr-1"
                          :class="
                            !inputIsValid && inputNumeroCarte != '' ? 'is-invalid' : 'valid'
                          "
                          @focus="viderMessageMel()"
                          @blur="validateFormInput()"
                        />

                        <span class="fin-numero-carte">-XXX (X)</span>
                        <div class="exemple-numero-carte mt-1">Ex. <b>12 345</b>-001 (1)</div>

                        <!-- Ce lien affiche le menu d'aide pour trouver le numéro de joueur du client -->
                        <Hyperlien class="lien-aide" :content="contentLienAideNumero"></Hyperlien>
                      </b-form-group>

                      <MessageMel
                        v-show="contentMessageMel.message"
                        :content="contentMessageMel"
                        class="mt-n2 mb-0 mx-0 mx-md-auto p-0"
                      ></MessageMel>

                      <Paragraphe
                        :content="{
                          richText: content.txtLegalSaisieCarte,
                        }"
                        class="texte-legal"
                      ></Paragraphe>

                      <button
                        :disabled="!inputNumeroCarte.length"
                        class="btn-sauvegarde btn btn-primaire d-block mx-md-0 mx-auto px-4"
                        @click="sauvegarderCarte(inputNumeroCarte)"
                      >
                        {{ content.libBoutonSauvegarder }}
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <!-- contenu pour clients non appariés RCU page d'erreur générique -->
                  <Paragraphe
                    :content="{
                      richText: content.txtPageErreurGenerique,
                      classeCSS: 'p-0',
                    }"
                  ></Paragraphe>
                </div>
                <!-- fin contenu clients non appariés RCU -->
              </div>
              <div v-else>
                <!-- Le client doit donner son consentement pour continuer -->
                <!-- MessageMel pour le retrait de la carte doit maintenant s'afficher sur la page de consetement -->

                <!-- la validation retraitCarte permet d'afficher ce MessageMel dans un seul cas précis (lors du retrait de la carte) et rien d'autre -->
                <MessageMel
                  v-show="contentMessageMel.message && retraitCarte"
                  :content="contentMessageMel"
                  class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
                ></MessageMel>

                <Paragraphe
                  :content="{
                    richText: content.txtConsentement,
                  }"
                ></Paragraphe>

                <Hyperlien :content="contentLienEnSavoirPlus"></Hyperlien>

                <Titre
                  :content="{
                    type: 'titre',
                    titre: content.titreConsentement,
                    classeCSS: 'text-left pt-1 pb-1',
                  }"
                >
                </Titre>

                <Paragraphe
                  :content="{
                    richText: content.txtConsentementSupplementaire,
                    classeCSS: 'pb-2',
                  }"
                ></Paragraphe>

                <button
                  class="btn btn-primaire d-block mx-md-0 mx-auto px-4"
                  @click="consentir()"
                >
                  {{ content.libBoutonConsentement }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
